/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IntroduceAnonymousLoginInput = {|
  clientMutationId?: ?string
|};
export type IntroduceAnonymousLoginMutationVariables = {|
  input: IntroduceAnonymousLoginInput
|};
export type IntroduceAnonymousLoginMutationResponse = {|
  +IntroduceAnonymousLogin: ?{|
    +token: ?string
  |}
|};
export type IntroduceAnonymousLoginMutation = {|
  variables: IntroduceAnonymousLoginMutationVariables,
  response: IntroduceAnonymousLoginMutationResponse,
|};
*/


/*
mutation IntroduceAnonymousLoginMutation(
  $input: IntroduceAnonymousLoginInput!
) {
  IntroduceAnonymousLogin(input: $input) {
    token
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IntroduceAnonymousLoginPayload",
    "kind": "LinkedField",
    "name": "IntroduceAnonymousLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntroduceAnonymousLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntroduceAnonymousLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "df06235639c05c555705462b9fc697b4",
    "id": null,
    "metadata": {},
    "name": "IntroduceAnonymousLoginMutation",
    "operationKind": "mutation",
    "text": "mutation IntroduceAnonymousLoginMutation(\n  $input: IntroduceAnonymousLoginInput!\n) {\n  IntroduceAnonymousLogin(input: $input) {\n    token\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a24a4809e227d87992dbec61de6e38a2';

module.exports = node;
